import React from 'react';
import backgroundTexts from '../../assets/svg/earufirst-loop-text.svg'

const FlowingImagesText = () => {

  return (
    <div className='follow-text-wrapper'>
        <div className='follow-text-container'>
            <div className="follow-text-slider">
              <img src={backgroundTexts} alt='background' className='loop-text'></img>
              <img src={backgroundTexts} alt='background' className='loop-text loop-text2'></img>
            </div>
        </div>
    </div>
  );
};


export {FlowingImagesText};